import React from "react";
import { Field } from "react-final-form";

const SubmitError = ({ name }) => (
  <Field
    name={name}
    subscription={{ submitError: true, dirtySinceLastSubmit: true }}
  >
    {({ meta: { submitError, dirtySinceLastSubmit } }) =>
      submitError && !dirtySinceLastSubmit ? (
        <div className="validation-label__error">
          <i>{submitError}</i>
        </div>
      ) : null
    }
  </Field>
);

export default SubmitError;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/SubmitError.js